import { useUtils } from '~/shared/hooks/useUtils';
import { useTranslation } from '~/shared/utils/translation';
import styles from './freight.module.scss';
import { FC } from 'react';

export interface FreightProps {
    cost?: number;
}

export const Freight: FC<FreightProps> = ({ cost }) => {
    const { translate } = useTranslation();
    const { convertPriceToLocale } = useUtils();

    return (
        <div className={styles.freightComponent}>
            <div className={styles.freightHeadline}>{translate('pdp.freightByCarrier')}</div>
            {cost !== undefined && (
                <div className={styles.freightCost}>
                    {translate('pdp.freightByCarrierPrice', {
                        amount: convertPriceToLocale(cost),
                    })}
                </div>
            )}
        </div>
    );
};
